<div class="tw-bg-[var(--surface-card)] p-4 tw-shadow-md tw-rounded tw-border-solid tw-border-gray-400 tw-border-2 tw-border-opacity-10" style="min-height: 100%;">
    <p-accordion class="w-full" [activeIndex]="activeIndex" (onOpen)="open()">
        <p-accordionTab [disabled]="!hasDropdown">            
            <ng-template pTemplate="header">
                <span class="spanHeader flex align-items-center gap-2 w-full tw-pr-8">
                    <div class="tw-mb-2 tw-flex tw-flex-row tw-items-center tw-justify-between">
                        <div class="tw-flex tw-flex-row">
                            <div *ngIf="iconTitle" [ngClass]="iconColor ?? 'tw-text-gray-500'">
                                <i  class="tw-mr-2 tw-text-xl" [ngClass]="iconTitle"></i>
                            </div>
                            <span class="tw-text-xl tw-font-medium tw-text-gray-900">{{ title }}</span>
                            <span *ngIf="required" class="tw-text-xl tw-font-bold tw-text-[var(--primary-color)]"> *</span>
                        </div>
                    </div>
                    <div class="tw-font-medium tw-text-gray-500 tw-mb-3">{{ subtitle }}</div>
                </span>
            </ng-template>            
            <div class="tw-pt-3">
                <div style="height: auto" class="tw-border-spacing-2">
                    <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
                </div>
            </div>
            <div class="tw-pt-3" *ngIf="hasSecondSection">
                <div class="tw-mb-2 tw-flex tw-flex-row tw-items-center tw-justify-between">
                    <div class="tw-flex tw-flex-row">
                        <div *ngIf="iconTitleSecond" [ngClass]="iconColorSecond ?? 'tw-text-gray-500'">
                            <i  class="tw-mr-2 tw-text-xl" [ngClass]="iconTitleSecond"></i>
                        </div>
                        <span class="tw-text-xl tw-font-medium tw-text-gray-900">{{ titleSecond }}</span>
                        
                        <span *ngIf="requiredSecond" class="tw-text-xl tw-font-bold tw-text-[var(--primary-color)]"> *</span>
                    </div>
                </div>
                <div class="tw-font-medium tw-text-gray-500 tw-mb-3">{{ subtitleSecond }}</div>    
                <p-divider layout="horizontal"></p-divider>
                <div style="height: auto" class="tw-border-spacing-2 ">
                    <ng-container [ngTemplateOutlet]="contentTemplateSecond"></ng-container>         
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
